import { omitEmptyValues, omitFalsyValues, snakeToCamelCaseParams, applyAxiosMiddleware } from '@uservoice/rest-utils';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import auth from '@/core/auth/AuthService';

applyAxiosMiddleware(axios, { fetchAuthToken });

// Strip out empty param values:
axios.interceptors.request.use((config: AxiosRequestConfig) => {
  if (config.allowFalseParams) {
    config.params = omitEmptyValues(config.params);
    config.data = omitEmptyValues(config.data);
  } else {
    config.params = omitFalsyValues(config.params);
    config.data = omitFalsyValues(config.data);
  }
  return config;
});

// Convert response values (except for pagination) to camelCase:
axios.interceptors.response.use((response: AxiosResponse<any>) => {
  if (response.data) {
    const { pagination, ...data } = response.data;
    response.data = snakeToCamelCaseParams(data);
    if (pagination) {
      response.data.pagination = pagination;
    }
  }
  return response;
});

async function fetchAuthToken(refresh?: boolean) {
  let token = auth.getToken();
  if (!token || refresh) {
    try {
      token  = await auth.refreshToken();
    } catch (error) {
      throw new Error('OAuth token not defined. Cannot use API');
    }
  }
  return `Bearer ${token}`;
}
